import {Injectable} from '@angular/core';
import {Observable, switchMap} from 'rxjs';
import {NativeServiceApiProvider} from 'src/app/services/native-api-provider.service';
import {ApiLearningUnitTeacher, ApiLessonInstance, ApiPersonalProfile} from '../../model/rest-model';
import {TeacherRestService} from "./teacher-rest.service";

@Injectable({
  providedIn: 'root',
})
export class TeacherRestServiceImpl implements TeacherRestService {

  constructor(public provider: NativeServiceApiProvider) {}

  createVideoClassroom(
    teacherId: number,
    lessonId: number
  ): Observable<ApiLessonInstance<ApiPersonalProfile, ApiLearningUnitTeacher>> {
    return this.provider
      .col()
      .pipe(switchMap((api) => api.createVideoClassroom(teacherId, lessonId)));
  }
}
